import { render, staticRenderFns } from "./PageTRAINS.vue?vue&type=template&id=0e9210db"
import script from "./PageTRAINS.vue?vue&type=script&lang=js"
export * from "./PageTRAINS.vue?vue&type=script&lang=js"
import style0 from "./PageTRAINS.vue?vue&type=style&index=0&id=0e9210db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports